<template>
  <div
    class="
      w-full
      flex flex-col
      shadow-card
      voucher-card
      rounded-2xl
      overflow-hidden
    "
  >
    <div class="bg-image voucher-image"></div>

    <div class="mx-8 mb-8 text-gray-4">
      <div class="mb-6">
        <h1 class="text-xl font-medium text-gray-5">
          {{ voucher.description }}
        </h1>
        <p class="text-sm whitespace-nowrap overflow-hidden">
          {{ voucher.info.address + ". " + voucher.info.commune }}
        </p>
      </div>

      <div
        class="text-sm flex justify-between align-middle"
        v-for="entry in voucher.entries"
        :key="entry.description"
      >
        <p class="leading-relaxed">{{ entry.description }}</p>
        <p class="leading-relaxed">{{ formatCurrency(entry.amount) }}</p>
      </div>

      <div class="separator"></div>

      <div class="flex justify-between align-middle">
        <p class="uppercase font-medium tracking-wider text-gray-6">Total</p>
        <p class="font-medium text-base-color">{{ totalValue }}</p>
      </div>
    </div>

    <div
      class="
        h-16
        pt-4
        leading-8
        text-xl
        font-book
        text-center
        align-middle
        select-none
        border-none
        shadow-button
        transition-colors
        duration-500
        rounded-md
        cursor-pointer
        bg-base-color
      "
      @click="payVoucher"
    >
      Pagar
    </div>
  </div>

  <svg width="0" height="0">
    <defs>
      <clipPath id="voucher-shape" clipPathUnits="objectBoundingBox">
        <path
          transform="scale(0.00313, 0.0047)"
          d="M0 14C0 6.268 6.26801 0 14 0H306C313.732 0 320 6.26801 320 14V159.662C320 165.843 315.937 171.308 309.995 173.008C179.57 210.329 53.2058 210.752 13.0966 209.764C5.68569 209.582 0 203.495 0 196.082V14Z"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss">
.voucher-card {
  max-width: 520px;
}

.separator {
  margin-top: 22px;
  margin-bottom: 18px;
  border: 1px solid #f3f7fb;
}

.voucher-image {
  height: 96px;
  width: 100%;
  clip-path: url(#voucher-shape);
  //mask-image: linear-gradient(rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 1));
  mask-image: linear-gradient(180deg, #ffffff 5%, rgba(255, 255, 255, 0) 80%);
}
</style>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Voucher } from "@/models/voucher";
import { PropType } from "@vue/runtime-core";

@Options({
  props: {
    voucher: {
      type: Object as PropType<Voucher>,
      require: true,
    },
  },
  emits: ["payVoucher"],
})
export default class VoucherCard extends Vue {
  voucher!: Voucher;

  payVoucher(): void {
    this.$emit("payVoucher");
  }

  get totalValue(): string {
    const totalValue =
      this.voucher.totalAmount ||
      this.voucher.entries.reduce((x, e) => x + e.amount, 0);
    return this.formatCurrency(totalValue);
  }

  formatCurrency(value: number): string {
    const v = Math.abs(Math.round(value)).toString();
    return (value < 0 ? "-$" : "$") + v.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
}
</script>
